<script>
import { mapGetters } from 'vuex'

import CharacterDialog from '@/components/widgets/CharacterDialog'
import Radio from '@/components/widgets/Radio'

export default {
  name: 'ViewRadios',

  components: {
    CharacterDialog,
    Radio
  },

  computed: {

    ...mapGetters([
      'playerRadioIds'
    ])

  }

}
</script>

<template>
  <div class="c-view-radios">
    <div class="c-view-radios-content">

      <!-- FIXME: this should be a dialog component -->
      <div class="c-view-radios-active-dialog">
        <character-dialog dialog-slug="testDialog" />
      </div>

      <div class="c-view-radios-list">
        <radio
          v-for="id in playerRadioIds"
          :key="id"
          :radio-id="id"
        />
      </div>

    </div>
  </div>
</template>

<style lang="scss">

.c-view-radios {
  @include fill-relative;
}

.c-view-radios-content {
  @include absolute;
  @include flex;
  @include flex-vertical;
  @include flex-center;
  width: 100%;
  height: 100%;
  max-height: 100%;
}

.c-view-radios-list {
  @include flex-fixed;
  @include grid;
  @include grid-columns(2);
  @include grid-gap($pad-horizontal, $pad-horizontal);
  @include push-pad-top-even;
  width: $width-content-very-loose;
  max-width: 100%;
}

.c-view-radios-active-dialog {
  @include flex-fluid;
  width: $width-content-loose;
  max-width: 100%;
}

</style>
